import { render, staticRenderFns } from "./Microregion.vue?vue&type=template&id=70e99631&"
import script from "./Microregion.vue?vue&type=script&lang=ts&"
export * from "./Microregion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports